import { getInstance } from "../../core/axios-gateway";
import type { TTenantSettingsDTO, TTenantSettingsResponse } from "../../types/tenant-settings";

const BASE_PATH = "/api/suppliers";

export const getSupplierTenantSettings = async (supplierId: string) => {
  return getInstance()
    .get<TTenantSettingsResponse>(`${BASE_PATH}/id/${supplierId}/settings`)
    .then((res) => res.data);
};

export const updateSupplierTenantSettings = async (
  supplierId: string,
  settings: TTenantSettingsDTO
) => {
  return getInstance()
    .put<TTenantSettingsResponse>(`${BASE_PATH}/id/${supplierId}/settings`, { settings })
    .then((res) => res.data);
};
